<template>
    <div>    
        <section class="page-section bg-light" id="listen">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-left">
                        <a href="https://johnswardson.bandcamp.com/track/the-storm">
                            <img src="https://f4.bcbits.com/img/a3199116593_16.jpg" height="300px" class="rounded mx-auto d-block mr-2 mb-3"/>
                        </a>
                        <hr>
                        <div class="mb-4">
                            <h2 class="mt-0 mb-0">
                                <b>The Storm</b> by John Swardson
                            </h2>
                            <p class="mb-1 text-muted text-sm">Follow John</p>
                            <a target="_blank" href="https://www.johnswardsonmusic.com/">
                                <img class="mr-2" src="img/linktree.png" height="25px" />
                            </a>
                            <a target="_blank"  href="https://open.spotify.com/artist/695QEt3yBqPBXCOIUXOips">
                                <img class="mr-2" src="img/spotify.svg" height="25px" />
                            </a>
                            <a target="_blank"  href="https://www.youtube.com/channel/UCRUVeEV6IWexGF4XL_c80TA">
                                <img class="mr-2" src="img/yt.png" height="25px" />
                            </a>
                            <a target="_blank"  href="https://www.instagram.com/jsilverdust/">
                                <img class="mr-2" src="img/ig.png" height="25px" />
                            </a>
                        </div>
                        <p class="mt-4">
                            In May of 2020, George Floyd was murdered by Derek Chauvin and several other Minneapolis Police on 38th and Chicago Ave. The event triggered widespread protesting across the Twin Cities resulting in violence against peaceful protesters, millions of dollars in propety damage and a cry for reform. During that time John Swardson, moved by the events of his community, wrote of that story in <b>The Storm</b>. His deep voice elicits a commanding tone over a folk guitar while recanting images from a time in which Minneapolis was broken. The song is ominous. The video was designed to capture a feeling of meloncholy and redemption.     
                         </p> 
                         <p>
                            After the events of George Floyd's death in May of 2020, many local businesses were damaged. If you are interested in giving back, please check out <a href="https://www.visitlakestreet.com/">Lake Street Council</a>.
                         </p>
                         <p>
                            John Swardson is a local singer/songwriter from the Twin Cities, Minnesota who was inspired by folk rock artists such as Willie Nelson, Springsteen. The video was produced by Raj Maitra (of Loonatic Productions).
                             
                          </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mb-0 mt-4">
                        <h3><b>Music Video</b></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 text-left"  v-for="item in items" v-bind:key="item.id">
                        <div class="mt-5">
                            <h3 class="h4 mb-2">
                                <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                    {{ item.title }}
                                </a>
                            </h3>
                        </div>
                        <div class="mt-2">
                            <a target="_blank" v-bind:href="'https://www.youtube.com/watch?v='+ item.id">
                                <img v-bind:src="'http://img.youtube.com/vi/'+ item.id + '/0.jpg'" async class="rounded w-90 shadow play-youtube-video lazy ">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        

    </div>
</template>

<script>
export default {
    name: 'Article1',
    components: {
    },
    data: function(){
        return{
            items: [
                { 
                    title: 'The Storm',  
                    id:'je5ZaK9hh0c'
                }
            ]
        }
    }
}
</script>